import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type IntroCallRequest = {
  id: string;
  user_id: string;
  carer_id: string;
  status: string;
  preferred_date?: string;
  preferred_time_from?: string;
  preferred_time_to?: string;
  message?: string;
  meeting_link?: string;
  care_type?: string;
  location?: string;
  created_at: string;
  updated_at: string;
  other_user_name: string;
  other_user_photo?: string;
  is_requester: boolean;
  has_review: boolean;
};

const useIntroCallRequests = () => {
  const queryFn = async (): Promise<IntroCallRequest[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_intro_call_requests', {
      method: 'POST',
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.requests || [];
  };

  return useQuery<IntroCallRequest[], Error>({
    queryKey: ['introCallRequests'],
    queryFn,
  });
};

export default useIntroCallRequests;
